import { render, staticRenderFns } from "./GroupInput.vue?vue&type=template&id=46ed21d2"
import script from "./GroupInput.vue?vue&type=script&lang=js"
export * from "./GroupInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports